// All user-facing timestamps across Ops IQ render in IST, regardless of the
// device's local timezone. Storage stays UTC ISO; conversion happens here.
export const IST_TZ = "Asia/Kolkata";

export function fmtIST(iso, { date = true, time = true } = {}) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    const opts = { timeZone: IST_TZ };
    if (date) Object.assign(opts, { day: "2-digit", month: "short", year: "numeric" });
    if (time) Object.assign(opts, { hour: "2-digit", minute: "2-digit", hour12: false });
    return d.toLocaleString("en-GB", opts);
}
